<template>
  <div class="page">
    <div class="div-header-select">
      <div class="div-center">
        <div>设备类型：</div>
        <el-select v-model="state" placeholder="请选择" size="medium">
          <el-option
            v-for="item in stateList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="div-center">
        <div>区域：</div>
        <el-cascader
          :props="areaProps"
          size="medium"
          v-model="areaIDSelect"
        ></el-cascader>
      </div>
      <div class="div-center">
        <div>时段：</div>
        <el-date-picker
          style="width: 320px"
          size="medium"
          v-model="daterange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :clearable=false
        >
        </el-date-picker>
      </div>
      <div class="div-center">
        <div style="width: 60px">搜索：</div>
        <el-input
          @keyup.enter.native="initQuery"
          placeholder="请输入房号"
          v-model="houseNameRegex"
           maxlength="10" 
          size="medium"
           clearable @clear="initQuery"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="initQuery"
          ></el-button>
        </el-input>
      </div>
    </div>

    <div class="div-2 div-2-top">
      <div>
        <el-button size="medium" @click="showDialog">手动抄表</el-button>
        <el-button size="medium" @click="showDialogUpload()"
          >批量导入</el-button
        >
        <el-button size="medium" @click="showBillsDialog">设置水电费</el-button>
        <el-button size="medium" @click="showMeterDialog">电表配置</el-button>
        <!-- <el-button size="medium" @click="showTopupDialog(0)">充值</el-button>
        <el-button size="medium" @click="showTopupDialog(1)">退款</el-button> -->
      </div>
      <div></div>
    </div>

    <main>
      <el-table :data="listData" style="width: 100%;"  height="calc(100vh - 200px)" >
        <template slot="empty">
          <img
            src="../../assets/list-none.png"
            alt=""
            width="400"
            class="table-empty"
          />
          <div>空荡荡的～暂无数据！</div>
        </template>
        <el-table-column prop="houseName" label="房号" align="center">
        </el-table-column>
        <el-table-column prop="areaName" label="所属区域" align="center">
        </el-table-column>
        <el-table-column prop="deviceType" label="设备类型" align="center">
        </el-table-column>
        <el-table-column prop="value" label="读数" align="center">
        </el-table-column>
        <el-table-column prop="recordTime" label="抄表时间" align="center">
        </el-table-column>
        <el-table-column
          prop="employeeName"
          label="抄表人员姓名"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="employeePhone"
          label="抄表人员电话"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="comment" label="描述" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              plain
              size="mini"
              @click="editItem(scope.row)"
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              plain
              size="mini"
              @click="deleteItem(scope.row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </main>

    <footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIdx"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="itemTotal"
        :page-sizes="[10, 20, 30, 40, 50]"
      >
      </el-pagination>
    </footer>

    <el-dialog
      :visible.sync="dialogVisible"
      title="手动抄表"
      width="50%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="div-2">
        <div class="div-2">
          <div class="div-2-title">房号</div>
          <el-autocomplete
            ref="searchInput"
            style="width: 100%"
            class="inline-input"
            :maxlength=10 
            v-model="formInput.houseName"
            :fetch-suggestions="querySearch"
            placeholder="请输入房号查询"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="queryAreas(formInput.houseName)"
            ></el-button>
          </el-autocomplete>
        </div>
        <div class="div-2">
          <div class="div-2-title">录入读数</div>
          <el-input v-model="formInput.meterValue"  maxlength="10" ></el-input>
        </div>
      </div>

      <div class="div-2 div-2-top">
        <div class="div-2">
          <div class="div-2-title">抄表时间</div>
          <el-date-picker
            style="width: 100%"
            v-model="formInput.opTime"
            type="datetime"
            placeholder="选择日期"
          >
          </el-date-picker>
        </div>
        <div class="div-2">
          <div class="div-2-title">设备类型</div>
          <el-select
            v-model="formInput.meterType"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option label="智能电表" value="智能电表"></el-option>
            <el-option label="智能水表" value="智能水表"></el-option>
            <el-option label="普通电表" value="传统电表"></el-option>
            <el-option label="普通水表" value="传统水表"></el-option>
          </el-select>
        </div>
      </div>
      <div class="div-2 div-2-top">
        <div class="div-2">
          <div class="div-2-title">抄表人姓名</div>
          <el-input maxlength="13"  v-model="formInput.opUserName"></el-input>
        </div>
        <div class="div-2">
          <div class="div-2-title">抄表人电话</div>
          <el-input  maxlength="11" v-model="formInput.opUserPhone"></el-input>
        </div>
      </div>
      
      <div class="div-2 div-2-top">
        <div class="div-2" >
           <div class="div-2-title">描述</div>
           <el-input type="textarea"  maxlength="200"  v-model="formInput.comment"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="medium"
          >取 消</el-button
        >
        <el-button type="primary" size="medium" @click="submitAdd"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogUploadVisible"
      :before-close="uploadClose"
      title="批量导入数据"
      width="50%"
    >
      <file-upload type="水电导入" :orgID="uploadOrgID" :file="dialogUploadFile"></file-upload>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogBillsVisible"
      title="设置水电费"
      width="50%"
    >
      <el-table :data="pricings">
        <el-table-column prop="house" label="房源类型" align="center">
        </el-table-column>
        <el-table-column prop="name" label="收费项目" align="center">
        </el-table-column>
        <el-table-column label="单价（元）" align="center">
          <template slot-scope="scope">
            <el-input-number
              :min="0"
              :max="9999"
              :step="scope.row.name === '电费' ? 0.0001 : 0.01"
              v-model="scope.row.price"
              type="primary"
              icon="el-icon-edit"
              plain
              size="mini"
              @click="editItem(scope.row)"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              plain
              size="mini"
              @click="editPrice(scope.row)"
              >确定</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogBillsVisible = false" size="medium"
          >取 消</el-button
        >
        <el-button type="primary" size="medium" @click="editPrice(pricings)"
          >批量修改</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="dialogMeterVisible"
      title="电表配置"
      width="680px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="div-2">
        <div class="div-2">
          <div class="div-2-title">抄表时间</div>
          <el-time-picker
            :clearable="false"
            value-format="HH:mm"
            format="HH:mm"
            style="width: 100%"
            v-model="formMeterInput.logTimePerDay"
            placeholder="选择时间"
          >
          </el-time-picker>
        </div>
        <div class="div-2">
          <div class="div-2-title">损耗比</div>
          <el-input-number
            v-model="formMeterInput.lossPercent"
            :min="0"
            :max="100"
          ></el-input-number>
        </div>
      </div>
      <!-- <div style="align:center"> -->
      <span slot="footer" class="dialog-footer">
        <el-button  @click="dialogMeterVisible = false" size="medium"
          >取 消</el-button
        >
        <el-button type="primary" size="medium" @click="submitEmeterConfig"
          >确 定</el-button
        >
      </span>
      <!-- </div> -->
    </el-dialog>

    <el-dialog
            width="500px"
      :visible.sync="dialogTopupVisible"
      :title="this.titleName"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form ref="form" :model="formTopupInput" label-width="80px">
        <div class="div-2">
          <el-row>
            <el-col :span="14">
              <el-form-item label="手机号" style="width:300px">
                <el-input clearable @clear="getFormTopupInput" v-model="queryPhone" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item>
                <el-button @click="getFormTopupInput(queryPhone)" size="medium">查询</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="div-2">
          <el-form-item label="姓名：" style="margin-left: 45px; margin-bottom: 0px;">
            <span>{{ this.formTopupInput.name}} </span>
          </el-form-item>
        </div>
        <div class="div-2">
          <el-form-item  label="房号：" style="margin-left: 45px; margin-bottom: 0px;">
            <span  v-for="(item,index) in Object.keys(this.formTopupInput.houses)" :key="index">
              <!-- <el-button round size="mini" v-if="index==0" style="padding: 5px 5px;margin-right: 10px; margin-left: -25px;"  type="info" plain>
               {{formTopupInput.houses[item]}}
              </el-button> -->
              <el-button round size="mini"  style="padding: 5px 5px;margin-right: 10px;"  type="info" plain>
                {{formTopupInput.houses[item]}}
              </el-button>
            </span>
          </el-form-item>
        </div>
        <div class="div-2">
          <el-form-item label="余额：" style="margin-left: 45px;">
            <span>{{ numFormat(this.formTopupInput.balance)}} </span>
            <!-- <span>余额：   {{this.formTopupInput.balance}} </span> -->
          </el-form-item>
        </div>
        <div  v-show="!this.isRefund" class="div-2" >
          <el-form-item  label="充值金额" >
              <el-input-number v-model="formTopupInput.amount" style="width:335px" :precision="2"  :min="0" ></el-input-number>
          </el-form-item>
        </div>
        <div v-show="this.isRefund" class="div-2">
          <el-form-item  label="退款金额" >
              <el-input-number v-model="formTopupInput.amount" style="width:335px" :precision="2"  :min="0" ></el-input-number>
          </el-form-item>
        </div>
        <div class="div-2" >
          <el-form-item label="备注" style="width:415px">
            <el-input type="textarea"  v-model="formTopupInput.comment"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTopupVisible = false" size="medium"
          >取 消</el-button
        >
        <el-button type="primary" size="medium" @click="submitTopup"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Utils from "../../Utils";
import { Loading } from "element-ui";
import FileUpload from "./FileUpload";
import { Decimal } from "decimal.js";
import mixins from "../../minix";

let _vue;

export default {
  mixins: [mixins],
  name: "home",
  components: { FileUpload },

  data() {
    return {
      uploadOrgID:"",//上传文件需要传递的组织id参数uploadOrgID
      tableHeight:0,
      pageIdx: 0,
      itemTotal: 0,
      queryPhone:'',
      dialogVisible: false,
      listData: [],
      isRefund: false,
      titleName: '',
      stateList: [
        {
          label: "全部",
          value: ""
        },
        {
          label: "普通水表",
          value: "传统水表"
        },
        {
          label: "普通电表",
          value: "传统电表"
        },
        {
          label: "智能电表",
          value: "智能电表"
        },
        {
          label: "智能水表",
          value: "智能水表"
        }
      ],
      state: "",

      houseNameRegex: "",
      areasList: [],
      areaID: "",
      areaIDSelect: ["全部区域"],
      areasMap: new Map(),

      daterange: this.defaultDateRange(),

      formInput: {
        meterType: "智能电表",
        meterValue: "",
        opTime: "",
        opUserName: "",
        opUserPhone: "",
        comment: "",
        houseID: "",
        houseName: ""
      },

      dialogUploadVisible: false,
      dialogUploadFile: "",

      areaProps: {
        checkStrictly: true,
        lazy: true,
        async lazyLoad(node, resolve) {
          let superAreaID = "";
          if (node.level > 0) {
            superAreaID = node.data.value;
          }
          let list = await _vue.areasQuery(superAreaID);
          let resolveData = [];
          if (list) {
            list.forEach(item => {
              resolveData.push({
                value: item.id,
                label: item.name
              });
            });
          }
          if (node.level === 0) {
            resolveData.unshift({
              value: "全部区域",
              label: "全部区域"
            });
          }
          resolve(resolveData);
        }
      },

      dialogBillsVisible: false,

      pricings: [],

      dialogMeterVisible: false,
      formMeterInput: {},

      dialogTopupVisible: false,
      house:{
        id:'',
        name:'',
        areaName:'',
      },
      formTopupInput: {
        houses:[],
        balance:0,
        amount:0,
      }
    };
  },

  created() {
    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", "Web_Admin");

    this.setTableHeight()
    this.query(0);
    this.queryAreas("");
    this.areasQuery("");

    _vue = this;
  },

  watch: {
    state() {
      this.initQuery();
    },

    areaIDSelect() {
      this.initQuery();
    },

    daterange() {
      this.initQuery();
    },
  },
    
  mounted() {
    // *****监听页面窗口改变函数  设置其宽高值 *****
    window.onresize = () => {
      return (() => {
        this.setTableHeight()
      })();
    };
  },
  methods: {
    defaultDateRange(){
      let now = new Date();
      let start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
      let end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
      return [start, end]
    },
    setTableHeight(){
      this.tableHeight = document.documentElement.clientHeight*0.8-50;
    },
    handleCurrentChange(val) { 
      this.pageIdx = val;
      this.query(val - 1);
    },

    querySearch(queryString, cb) {
      cb(this.areasList);
    },

    handleSizeChange(val) { 
      this.pageIdx = 0;
      this.pageSize = val;
      this.query(0);
    },

    async showBillsDialog() {
      this.dialogBillsVisible = true;
      this.getBillsList();
    },

    editPrice(data) {
      let list = [];
      if (Array.isArray(data)) {
        data.forEach(item => {
          list.push({
            name: item.house,
            pricings: [
              {
                name: item.name,
                price: new Decimal(item.price)
                  .mul(new Decimal(10000))
                  .toNumber()
              }
            ]
          });
        });
      } else {
        list.push({
          name: data.house,
          pricings: [
            {
              name: data.name,
              price: new Decimal(data.price).mul(new Decimal(10000)).toNumber()
            }
          ]
        });
      }

      const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
      axios({
        method: "post",
        url: "meters/pricings/edit",
        data: {
          data: list
        }
      })
        .then(value => {
          let message = value.data.message;
          if (value.data.code === 0) {
            this.$message.success(message);
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {
          this.$message.error("操作失败");
        })
        .finally(()=>{
          loading.close();
        });
    },

    getBillsList() {
      
      const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
      axios({
        method: "post",
        url: "meters/pricings/query"
      }).then(value => {
        this.pricings = [];
        value.data.data.forEach(item => {
          item.pricings.forEach(data => {
            let price;

            if (data.name === "水费") {
              price = new Decimal(data.price)
                .div(new Decimal(10000))
                .toNumber()
                .toFixed(2);
            } else {
              price = new Decimal(data.price)
                .div(new Decimal(10000))
                .toNumber()
                .toFixed(4);
            }

            this.pricings.push({
              house: item.name,
              name: data.name,
              price: price
            });
          });
        });
      }).finally(()=>{
          loading.close();
        });
    },

    editItem(item) {
      let _vue = this;
      let tmp = item.areaName ? item.areaName + '-' : ''
      this.$prompt(
         `${tmp}${item.houseName}-${item.deviceType}（关联的账单金额会同步修改）`,
        "修改抄表",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputValue:item.value,
          inputPattern: /[0-9]\d*/,
          inputErrorMessage: "只能输入数值",
          closeOnClickModal: false
        }
      )
        .then(({ value }) => {
          const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
          axios({
            method: "post",
            url: "meters/records/edit",
            data: {
              recordID: item.id,
              meterValue: value,
              meterID: item.deviceID
            }
          })
            .then(value => {
              if (value.data.code != 0) { // 编辑失败显示提示信息
                loading.close();
                _vue.$message({
                  type: "error",
                  message: value.data.message
                });
              } else { // 编辑成功刷新页面
                _vue.query(_vue.pageIdx - 1);
              }
            })
            .finally(() => {
            }).catch(() => {loading.close();});
        });
    },

    deleteItem(item) {
      let _vue = this;
      let tmp = item.areaName ? item.areaName + '-' : ''
      this.$confirm(
        `是否删除【${tmp}${item.houseName}-${
          item.deviceType
        }】的抄表记录：${item.value}？（关联的账单会同步删除）`,
        "删除抄表",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false
        }
      ).then(() => {
        const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
        axios({
          method: "post",
          url: "meters/records/delete",
          data: {
            recordID: item.id,
            meterID: item.deviceID
          }
        })
          .then(value => {
            if (value.data.code != 0) {
              loading.close();
              _vue.$message.error(value.data.message);
            } else{
              _vue.$message({
                type: "success",
                message: value.data.message
              });
              _vue.query(_vue.pageIdx - 1);
            }
          })
          .finally(() => {}).catch(() => {loading.close()})
      })
    },

    async showDialogUpload() {
      this.uploadOrgID = this.$route.query.orgID
      let data = {
        houseNameRegex: this.houseNameRegex,
        deviceType: this.state
      };
      if (this.areaIDSelect.length > 0) {
        data.areaID = this.areaIDSelect[this.areaIDSelect.length - 1];
      }
      const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
      await axios({
        method: "post",
        url: "meters/tpl/generate",
        data: data
      })
        .then(value => {
          if (value.data.code === 0) {
            this.dialogUploadFile = value.data.data;
            this.dialogUploadVisible = true;
          } else {
            this.$message.error(value.data.message);
          }
        })
        .catch(() => {})
        .finally(()=>{
          loading.close();
        });
    },

    async areasQuery(superAreaID) {
      let returnData = [];
      const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
      await axios({
        method: "post",
        url: "areas/query",
        data: {
          pageIdx: 0,
          pageSize: 100,
          superAreaID: superAreaID
        }
      })
        .then(value => {
          returnData = value.data.data;
        })
        .catch(() => {})
        .finally(()=>{
          loading.close();
        });
      return returnData;
    },

    queryAreas(input) {
      const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
      axios({
        method: "post",
        url: "areas/list",
        data: {
          houseNameRegex: input,
          pageIdx: 0,
          pageSize: 100
        }
      })
        .then(value => {
          this.areasList = [];
          if (value && value.data && value.data.data) {
            value.data.data.forEach(item => {
              item.value = item.areaName + ' ' + item.name;
              item.address = item.id;
              this.areasList.push(item);
              this.areasMap.set(item.value, item.address);
              this.$refs.searchInput.focus();
            });
          }
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
          if (this.areasList.length === 0) {
            this.$message.error("无数据");
          }
        });
    },

    showDialog() {
      const date = new Date()
      date.setHours(8)
      date.setMinutes(0)
      date.setSeconds(0)
      this.formInput = {
        meterType: "智能电表",
        meterValue: "0",
        opTime: date.getTime(),
        opUserName: "",
        opUserPhone: "",
        houseID: "",
        comment:""
      };
      if (this.areasList.length > 0) {
        this.formInput.houseID = this.areasList[0].id;
      }
      this.dialogVisible = true;
    },

    async showMeterDialog() {
      let url = axios.defaults.baseURL + "devices/emeters/config/get";
      url = url.replace("org/", "");
      const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
      await axios({
        method: "post",
        url: url,
        data: {
          emeterType: "智能电表"
        }
      })
        .then(value => {
          if (value.data.code === 0) {
            this.formMeterInput = value.data.data;
          } else {
            this.$message.error(value.data.message);
          }
        })
        .catch(() => {})
        .finally(()=>{
          loading.close();
        });
      this.dialogMeterVisible = true;
    },

    submitEmeterConfig() {
      let url = axios.defaults.baseURL + "devices/emeters/config";
      url = url.replace("org/", "");
      this.formMeterInput.emeterType = "智能电表";
      const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
      axios({
        method: "post",
        url: url,
        data: this.formMeterInput
      })
        .then(value => {
          if (value.data.code === 0) {
            this.$message.success(value.data.message);
            this.dialogMeterVisible = false;
          } else {
            this.$message.error(value.data.message);
          }
        })
        .catch(() => {})
        .finally(()=>{
          loading.close();
        });
    },

//查询账单信息

 getFormTopupInput(row){
    this.formTopupInput = {
      houses:[],
      balance:0,
      amount:0,
    };
   if(!row){
     this.$message.error("请输入手机号");
    return
   }
      let data = {
        phone: row,
        orgID: this.$route.query.orgID ,
        pageSize: this.pageSize,
        pageIdx: 0
      };
      const loading = Loading.service({
        lock: true,
        text: "正在请求中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
      axios({
        method: "post",
        url: "wallets",
        data: data
      })
        .then(
          value => {
            if (value.data.code != 0) { 
              this.$message.error(value.data.message);
              return
            }
          if (value && value.data && value.data.data) {
            if(value.data.data.length==0){
              this.$message.error("未查询到数据");
              return
            }
            let data ={
              id: value.data.data[0].id,
              name: value.data.data[0].name,
              phone: value.data.data[0].phone,
              // housesName: value.data.data[0].houses[0].name,
              houses:value.data.data[0].houses,
              balance:value.data.data[0].balance,
              comment: ""
            }
            //将单位元转分
            data.balance = new Decimal(data.balance).div(new Decimal(100)).toNumber();
            
            //  data.amount = data.amount / 100
            if(this.titleName=="退款"){
              data.amount=data.balance 
            }else{
              data.amount=0
            }
            this.formTopupInput=data
            this.formTopupInput.houses=[]
            value.data.data[0].houses.forEach(item => {
              this.formTopupInput.houses.push(item.areaName+" "+item.name);
            });
          }
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
        });
 },
    showTopupDialog(row) {
      this.queryPhone=""
      this.formTopupInput = {
        id: "",
        name: "",
        phone: "",
        houses: [],
        balance:0,
        amount: 0,
        comment: ""
      };
      //充值
      if(row==0){
        this.titleName ='充值'
        this.isRefund =false
      }else if (row==1){
      //退款
        this.titleName ='退款'
        this.isRefund =true
      }
      this.dialogTopupVisible = true;
    },
//退款\充值
    submitTopup() {
      if(!this.formTopupInput.id){
              this.$message.error("请选择账 "+this.titleName+" 账户");
              return
      }
       if(this.formTopupInput.amount===0){
          this.$message.error("请输入 "+this.titleName+" 金额");
          return
        }
      let data = { 
        userID:this.formTopupInput.id,
        amount:this.formTopupInput.amount,
        comment:this.formTopupInput.comment,
        orgID:this.$route.query.orgID
         };
      const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
      let reqUrl='';
      if(this.titleName=='充值'){
        reqUrl ='wallets/topup'
      }else if (this.titleName=='退款'){
        if (this.formTopupInput.amount>this.formTopupInput.balance){
          this.$message.error(this.titleName+"金额不能大于账户余额");
          return
        }
      reqUrl ='wallets/refund'
      }
        //将单位元转分
      data.amount = new Decimal(data.amount).mul(new Decimal(100)).toNumber();
      // data.amount = data.amount * 100
      axios({
        method: "post",
        url: reqUrl,
        data: data
      })
        .then(value => {
          if (value.data.code === 0) {
            this.$message.success(value.data.message);
            this.dialogTopupVisible = false;
          } else {
            this.$message.error(value.data.message);
          }
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
        });
    },

    submitAdd() {
      if (!(this.formInput.opUserName.length <= 0 && this.formInput.opUserPhone.length <= 0)) {
        this.$message.error("请输入抄表人员信息");
        return;
      }
      let data = { ...this.formInput };
      data.opTime = parseInt(new Date(data.opTime).getTime() / 1000 + "");


      if (!this.areasMap.has(this.formInput.houseName)) {
        this.$message.error("请输入房号搜索并选择房间");
        return;
      }
      data.houseID = this.areasMap.get(this.formInput.houseName);

      const loading = Loading.service({
        lock: true,
        text: "正在请求中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
      axios({
        method: "post",
        url: "meters/records/add",
        data: data
      })
        .then(value => {
          loading.close();
          if (value.data.code === 0) {
            this.$message.success(value.data.message);
            this.dialogVisible = false;
            this.pageIdx = 0;
            this.query(0);
          } else {
            this.$message.error(value.data.message);
          }
        })
        .catch(() => {})
          .finally(()=>{
            loading.close();
          });
    },

    uploadClose(done) {
      this.pageIdx = 0;
      this.query(0);
      done();
    },

    initQuery() {
      this.pageIdx = 0;
      this.query(0);
    },

    //列表查询
    query(pageIdx) {
      if (pageIdx <= 0) {
        pageIdx = 0;
      }

      let data = {
        houseNameRegex: this.houseNameRegex,
        deviceType: this.state,
        pageSize: this.pageSize,
        pageIdx: pageIdx
      };

      if (this.areaIDSelect.length > 0) {
        data.areaID = this.areaIDSelect[this.areaIDSelect.length - 1];
      }

      if (Array.isArray(this.daterange)) {
        data.start = parseInt(this.daterange[0].getTime() / 1000);
        data.end = parseInt(
          this.daterange[1].getTime() / 1000 + 60 * 60 * 24 - 1
        );
      }

      const loading = Loading.service({
        lock: true,
        text: "正在请求中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });

      axios({
        method: "post",
        url: "meters/records/query",
        data: data
      })
        .then(value => {
          this.listData = [];
          this.itemTotal = value.data.total;
          if (value && value.data && value.data.data) {
            this.setTableHeight()
            value.data.data.forEach(item => {
              item.recordTime = Utils.long2second(item.recordTime * 1000);
              item.deviceType = item.deviceType.toString().replace("传统", "普通");
              this.listData.push(item);
            });
          }
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
        });
    }
  }
};
</script>

<style>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.el-input-group__prepend {
  width: 140px !important;
}
.el-input-group--prepend {
  margin-bottom: 10px;
}
</style>

<style lang="scss" scoped>
@import "../../style.css";
main {
  margin-top: 10px;
}
.div-2-title {
  max-width: 80px;
  min-width: 70px;
}
</style>